{
  "profile": "Perfil",
  "nbOfUsers": "Número de usuarios",
  "validation": {
    "name": "El nombre del perfil es obligatorio",
    "maxLength": "El nombre debe tener un máximo de 50 caracteres"
  },
  "roles": "Funciones",
  "name": "Nombre del perfil",
  "empty": "Ninguna función disponible",
  "confirmDelete": {
    "title": "Eliminación de un grupo",
    "description": "Se eliminará el perfil seleccionado \"{userProfileName}\""
  },
  "cannotDelete": {
    "title": "No se puede eliminar el perfil",
    "description": "El perfil seleccionado \"{userProfileName}\" está asociado a {usersCount} usuarios"
  },
  "button": {
    "delete": "Eliminar el perfil"
  },
  "identity": "Identidad",
  "new": "Nuevo perfil",
  "label": {
    "operator": "Operador",
    "administrator": "Administrador"
  }
}
